// extracted by mini-css-extract-plugin
export default {"base":"CbsaStats_base__ylQuQ","header":"CbsaStats_header__sQ4zp","scrollList":"CbsaStats_scrollList__HA0aB"};